import { MODULES } from "#constants/modules"
import Course from "#training/pages/Course"
import Index from "#training/pages/Index"
import AutoStoriesIcon from '@mui/icons-material/AutoStories'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import Groups2Icon from '@mui/icons-material/Groups2'
import PostAddIcon from "@mui/icons-material/PostAdd"
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import RecentActorsIcon from "@mui/icons-material/RecentActors"
import Colaborador from "./pages/Colaborador"
import PorAprobar from "./pages/PorAprobar"
import Statistics from "./pages/Statistics"
import TablaColaboradores from "./pages/TablaColaboradores"
import PERMISOS from "#constants/perfiles"

export const URLS = {
  Capacitaciones: [
    {
      module: MODULES.TRAINING,
      path: "training/mis-cursos",
      element: <Colaborador />,
      title: "Mis Cursos",
      icon: FolderSharedIcon ,
      permissions: [],
      textDivider: "annul_plan",
    },
    {
      module: MODULES.TRAINING,
      path: "training/cursos",
      element: <Course />,
      title: "Cursos",
      icon: AutoStoriesIcon ,
      permissions: [...PERMISOS.RH_ALL,...PERMISOS.GRTE_ALL,PERMISOS.SEGURIDAD_HIGIENE],
      textDivider: "annul_plan",
    },
    {
      module: MODULES.TRAINING,
      path: "training/Plantación",
      element: <Index />,
      title: "Plan de Capacitación",
      icon: PostAddIcon ,
      permissions: [...PERMISOS.RH_ALL,...PERMISOS.GRTE_ALL,PERMISOS.SEGURIDAD_HIGIENE,PERMISOS.MANAGEMENT_OP],
      textDivider: "annul_plan",
    },
    {
      module: MODULES.TRAINING,
      path: "training/por-aprobar",
      element: <PorAprobar />,
      title: "Por Aprobar",
      icon: RecentActorsIcon ,
      permissions: [...PERMISOS.RH_ALL,PERMISOS.SEGURIDAD_HIGIENE],
      textDivider: "annul_plan",
    },
    {
      module: MODULES.TRAINING,
      path: "training/statistics",
      element: <Statistics />,
      title: "Estadísticas",
      icon: QueryStatsIcon ,
      permissions: [...PERMISOS.RH_ALL,PERMISOS.SEGURIDAD_HIGIENE,PERMISOS.MANAGEMENT_OP,PERMISOS.GRTE],
      textDivider: "annul_plan",
    },
    {
      module: MODULES.TRAINING,
      path: "training/colaboradores",
      element: <TablaColaboradores />,
      title: "Colaboradores",
      icon: Groups2Icon ,
      permissions: [...PERMISOS.RH_ALL,...PERMISOS.GRTE_ALL,PERMISOS.MANAGEMENT_OP,PERMISOS.SEGURIDAD_HIGIENE],
      textDivider: "annul_plan",
    },
  ],
};
